/* eslint-disable react/require-default-props */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'ramda';
import ui from 'redux-fui';
import Footer from '../components/Global/Footer';
import ConnectedHeader from '../components/Global/Header';
import { load as loadAuth } from '../stores/auth';
import safelyHoistStatics from '../helpers/safelyHoistStatics';

/**
 * Helper component that will render singular components server side in the context
 * of the application
 */
class StaticComponentRenderer extends Component {
  static fetchData(store) {
    return store.dispatch(loadAuth());
  }

  render() {
    let element;

    switch (this.props.match.params.component) {
      case 'header':
        element = (
          <ConnectedHeader user={this.props.user} callback={this.onNavToggle} />
        );
        break;
      case 'footer':
        element = <Footer />;
        break;
      default:
        return false;
    }

    return (
      <Route
        render={({ staticContext }) => {
          if (staticContext) {
            // eslint-disable-next-line no-param-reassign
            staticContext.componentRender = true;
          }

          return element;
        }}
      />
    );
  }
}

StaticComponentRenderer.propTypes = {
  match: PropTypes.object.isRequired,
  user: PropTypes.object
};

const mapStateToProps = state => ({ user: state.auth.user });

const appComposition = compose(
  withRouter,
  ui({
    key: 'app',
    state: {
      headerShouldShowCTA: false,
      animateSearchForm: false
    }
  }),
  connect(mapStateToProps)
)(StaticComponentRenderer);

export default safelyHoistStatics(appComposition, StaticComponentRenderer);
